import { ScoreSquare } from "@/components/terminal/band-mark"
import { dataByAssessmentBand } from "@/constants/terminal/assessment-band"
import type { TerminalAssessment } from "@/lib/terminal/file-view"
import { cn } from "@/lib/utils"

// The masthead's mark, or the swarm tooltip's row-size one.
const classNamesBySize = {
  masthead: { gap: "gap-3", word: "band-word-masthead" },
  row: { gap: "gap-2", word: "band-word-s" },
}

// The current score's square beside the band's word in the band's hue. A
// score's move shows only in Reassessments (Dhanur, 26 Oct 2026).
export const MastheadAssessment = ({
  assessment,
  size = "masthead",
}: {
  assessment: Pick<TerminalAssessment, "band" | "score">
  size?: keyof typeof classNamesBySize
}) => {
  const { label, color } = dataByAssessmentBand[assessment.band]
  const classNames = classNamesBySize[size]
  return (
    <span
      className={cn(
        "inline-flex items-center whitespace-nowrap",
        classNames.gap
      )}
    >
      <ScoreSquare
        band={assessment.band}
        score={assessment.score}
        size={size}
      />
      <span
        aria-hidden="true"
        className={cn(
          "font-display font-black tracking-wide uppercase",
          classNames.word
        )}
        style={{ color }}
      >
        {label}
      </span>
    </span>
  )
}
